const apisConfig = {
  apis: {
    api:
      process.env.NODE_ENV === "production" &&
      process.env.REACT_APP_HOST_ENV === "production"
        ? {
          protocol: "https",
          host: process.env.BACKEND_URI || "api.suarte.art",
          port: process.env.BACKEND_PORT || "443",
        }
        : {
          protocol: process.env.REACT_APP_BACKEND_PROTOCOL || process.env.BACKEND_PROTOCOL || "https",
          host: process.env.REACT_APP_BACKEND_URI || process.env.BACKEND_URI || "dev.suarte.art",
          port: process.env.REACT_APP_BACKEND_PORT || process.env.BACKEND_PORT || "443",
        },
  },
};

// Normalize host/port if host already contains a port (e.g. "192.168.0.211:3001")
(() => {
  const api = apisConfig.apis.api;
  let { host, port } = api;
  if (typeof host === "string" && host.includes(":")) {
    try {
      const parsed = new URL(`${api.protocol}://${host}`);
      host = parsed.hostname;
      // Only override port if one was embedded in host and no explicit port was provided
      if (!port) {
        port = parsed.port;
      }
    } catch (_err) {
      // fall back to the raw host/port values
    }
  }
  api.host = host;
  api.port = port;
})();

const portSuffix = apisConfig.apis.api.port ? `:${apisConfig.apis.api.port}` : "";
apisConfig.apis.api.url = `${apisConfig.apis.api.protocol}://${apisConfig.apis.api.host}${portSuffix}`;
const wsProtocol = apisConfig.apis.api.protocol === "https" ? "wss" : "ws";
apisConfig.apis.api.wsUrl = `${wsProtocol}://${apisConfig.apis.api.host}${portSuffix}`;
apisConfig.apis.api.socketPath =
  process.env.REACT_APP_SOCKET_PATH
  || process.env.BACKEND_SOCKET_PATH
  || "/socket.io";
apisConfig.apis.api.socketEventName =
  process.env.REACT_APP_SOCKET_EVENT_NAME
  || process.env.BACKEND_SOCKET_EVENT_NAME
  || "auction:event";
apisConfig.apis.api.socketBacklogEvent =
  process.env.REACT_APP_SOCKET_BACKLOG_EVENT
  || process.env.BACKEND_SOCKET_BACKLOG_EVENT
  || "auction:backlog";
apisConfig.apis.api.socketSubscribeEvent =
  process.env.REACT_APP_SOCKET_SUBSCRIBE_EVENT
  || process.env.BACKEND_SOCKET_SUBSCRIBE_EVENT
  || "artwork:subscribe";
apisConfig.apis.api.socketUnsubscribeEvent =
  process.env.REACT_APP_SOCKET_UNSUBSCRIBE_EVENT
  || process.env.BACKEND_SOCKET_UNSUBSCRIBE_EVENT
  || "artwork:unsubscribe";

export default apisConfig;
